import { render, staticRenderFns } from "./CreateFeatureEvent.vue?vue&type=template&id=13f0d648&"
import script from "./CreateFeatureEvent.vue?vue&type=script&lang=js&"
export * from "./CreateFeatureEvent.vue?vue&type=script&lang=js&"
import style0 from "./CreateFeatureEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports